// extracted by mini-css-extract-plugin
export default {"container":"lgsIaO","itemList":"Y1twUU","itemWrapper":"RXdrrT"};